/**
 * Default email subjects for different template types
 * Centralized translations to avoid code duplication
 */

export const DEFAULT_SUBJECTS = {
  paymentFailed: {
    es: "Pago no procesado correctamente",
    en: "Payment not processed correctly",
    ca: "Pagament no processat correctament",
    fr: "Paiement non traité correctement",
    eu: "Ordainketa ez da behar bezala prozesatu",
    de: "Zahlung wurde nicht korrekt verarbeitet",
    it: "Pagamento non elaborato correttamente",
    pt: "Pagamento não processado corretamente",
    ru: "Платеж обработан неправильно",
    nl: "Betaling niet correct verwerkt",
    ko: "결제가 올바르게 처리되지 않았습니다",
    da: "Betaling ikke behandlet korrekt",
    hu: "A fizetés nem lett megfelelően feldolgozva",
    ja: "支払いが正しく処理されませんでした",
    ro: "Plata nu a fost procesată corect",
    zh: "付款未正确处理",
  },
  abandonedPayment: {
    es: "Pago pendiente de completar",
    en: "Payment pending completion",
    ca: "Pagament pendent de completar",
    fr: "Paiement en attente d'achèvement",
    eu: "Ordainketa osatzen dago",
    de: "Zahlung steht noch aus",
    it: "Pagamento in attesa di completamento",
    pt: "Pagamento pendente de conclusão",
    ru: "Платеж ожидает завершения",
    nl: "Betaling wacht op voltooiing",
    ko: "결제 완료 대기 중",
    da: "Betaling afventer gennemførelse",
    hu: "A fizetés befejezésre vár",
    ja: "支払いの完了待ち",
    ro: "Plată în așteptarea finalizării",
    zh: "付款待完成",
  },
  cartAbandonment: {
    en: "Recover your cart!",
    ca: "Recupera el carret!",
    fr: "Récupérez votre panier numérique!",
    eu: "Berreskuratu zure erosketa saskia!",
    es: "¡Recupera tu carrito!",
    de: "Holen Sie Ihren Warenkorb zurück!",
    it: "Recupera il tuo carrello!",
    pt: "Recupere o seu carrinho!",
    ru: "Верните свою корзину!",
    nl: "Herstel je winkelwagen!",
    ko: "장바구니를 복구하세요!",
    da: "Gendan din kurv!",
    hu: "Állítsd vissza a kosaradat!",
    ja: "カートを復元しましょう!",
    ro: "Recuperează-ți coșul!",
    zh: "找回您的购物车!",
  },
  upsell: {
    es: "¡Mejora tu estancia!",
    en: "Improve your stay!",
    ca: "Millora la teva estada!",
    fr: "Améliorez votre séjour !",
    eu: "Hobetu zure egonaldia!",
    de: "Verbessern Sie Ihren Aufenthalt!",
    it: "Migliora il tuo soggiorno!",
    pt: "Melhore a sua estadia!",
    ru: "Улучшите своё пребывание!",
    nl: "Verbeter je verblijf!",
    ko: "숙박을 더 좋게 하세요!",
    da: "Forbedr dit ophold!",
    hu: "Tedd jobbá a tartózkodásodat!",
    ja: "ご滞在をより快適に!",
    ro: "Îmbunătățește-ți sejurul!",
    zh: "提升您的入住体验!",
  },
  quotation: {
    es: "Detalles de su cotización",
    en: "Your quotation details",
    ca: "Detalls de la seva cotització",
    fr: "Détails de votre devis",
    eu: "Zure aurrekontuaren xehetasunak",
    de: "Einzelheiten zu Ihrem Angebot",
    it: "Dettagli del suo preventivo",
    pt: "Detalhes da sua cotação",
    ru: "Подробности вашего предложения",
    nl: "Details van uw offerte",
    ko: "견적 세부 정보",
    da: "Detaljer om dit tilbud",
    hu: "Az ajánlatod részletei",
    ja: "お見積もりの詳細",
    ro: "Detaliile ofertei tale",
    zh: "您的报价详情",
  },
  waitingList: {
    es: "¡Ya tenemos disponibilidad!",
    en: "We already have availability!",
    ca: "Ja tenim disponibilitat!",
    fr: "Nous avons déjà de la disponibilité !",
    eu: "Dagoeneko erabilgarritasuna dugu!",
    de: "Wir haben bereits Verfügbarkeit!",
    it: "Abbiamo già disponibilità!",
    pt: "Já temos disponibilidade!",
    ru: "У нас уже есть доступность!",
    nl: "We hebben al beschikbaarheid!",
    ko: "이미 예약이 가능합니다!",
    da: "Vi har allerede ledighed!",
    hu: "Már van szabad helyünk!",
    ja: "空室が出ました!",
    ro: "Avem deja disponibilitate!",
    zh: "我们已经有空房了!",
  },
  loyaltyWelcome: {
    es: "Confirmación de registro",
    en: "Registration confirmation",
    ca: "Confirmació de registre",
    fr: "Confirmation d'inscription",
    eu: "Erregistroaren berrespena",
    de: "Registrierungsbestätigung",
    it: "Conferma di registrazione",
    pt: "Confirmação de registro",
    ru: "Подтверждение регистрации",
    nl: "Registratiebevestiging",
    ko: "등록 확인",
    da: "Bekræftelse af registrering",
    hu: "Regisztráció megerősítése",
    ja: "登録の確認",
    ro: "Confirmarea înregistrării",
    zh: "注册确认",
  },
  agencies: {
    es: "Confirmación de registro",
    en: "Registration confirmation",
    ca: "Confirmació de registre",
    fr: "Confirmation d'inscription",
    eu: "Erregistroaren berrespena",
    de: "Registrierungsbestätigung",
    it: "Conferma di registrazione",
    pt: "Confirmação de registro",
    ru: "Подтверждение регистрации",
    nl: "Registratiebevestiging",
    ko: "등록 확인",
    da: "Bekræftelse af registrering",
    hu: "Regisztráció megerősítése",
    ja: "登録の確認",
    ro: "Confirmarea înregistrării",
    zh: "注册确认",
  },
};

/**
 * Get a default subject for a given type and locale
 * @param {string} type - The subject type (e.g., 'paymentFailed', 'cartAbandonment')
 * @param {string} locale - The locale code (e.g., 'en', 'es', 'ca')
 * @returns {string} The translated subject or English fallback
 */
export function getDefaultSubject(type, locale) {
  const subjects = DEFAULT_SUBJECTS[type];
  if (!subjects) {
    console.warn(`Unknown subject type: ${type}`);
    return "";
  }
  return subjects[locale] || subjects.en;
}
